function CustomAlert({
    type = "info",
    title = "Are you sure?",
    message = "",
    confirmText = "OK",
    cancelText = "Cancel",
    showCancel = false,
    onConfirm = () => { },
    onCancel = () => { },
    closeOnBackdrop = true,
}) {
    const types = {
        success: "bg-green-100 text-green-600",
        error: "bg-red-100 text-red-600",
        warning: "bg-yellow-100 text-yellow-600",
        info: "bg-blue-100 text-blue-600",
    };

    // Create wrapper
    const wrapper = document.createElement("div");
    wrapper.className =
        "fixed inset-0 z-[9999] hidden items-center justify-center";

    wrapper.innerHTML = `
    <!-- Backdrop -->
    <div class="absolute inset-0 bg-black/50 backdrop-blur-sm"></div>

    <!-- Modal -->
    <div class="relative z-10 w-full max-w-sm mx-4 rounded-2xl bg-white p-6 shadow-2xl
                animate-[fadeIn_0.2s_ease-out,scaleIn_0.2s_ease-out]">
      
      <div class="flex justify-center mb-3">
        <div class="w-12 h-12 rounded-full flex items-center justify-center text-2xl font-semibold ${types[type]}">
          ${type === "success"
            ? "✓"
            : type === "error"
                ? "✕"
                : type === "warning"
                    ? "!"
                    : "i"
        }
        </div>
      </div>

      <div class="text-center mb-6">
        <h2 class="text-lg font-semibold text-slate-900">${title}</h2>
        ${message
            ? `<p class="text-sm text-slate-600 mt-1">${message}</p>`
            : ""
        }
      </div>

      <div class="flex justify-center gap-2">
        ${showCancel
            ? `<button id="alert-cancel"
                class="px-4 py-2 text-sm rounded-xl rounded-tr-md border border-slate-200 
                       text-slate-700 hover:bg-slate-50 transition">
                ${cancelText}
              </button>`
            : ""
        }
        
        <button id="alert-confirm"
          class="px-4 py-2 text-sm rounded-xl rounded-tl-md font-semibold 
                 bg-slate-900 text-white hover:bg-slate-800 transition">
          ${confirmText}
        </button>
      </div>
    </div>

    <style>
      @keyframes fadeIn { from {opacity:0;} to {opacity:1;} }
      @keyframes scaleIn { from {transform:scale(.9);} to {transform:scale(1);} }
    </style>
  `;

    document.body.appendChild(wrapper);
    setTimeout(() => wrapper.classList.replace("hidden", "flex"), 10);

    // Close logic
    const cleanup = () => {
        wrapper.classList.replace("flex", "hidden");
        setTimeout(() => wrapper.remove(), 150);
    };

    if (closeOnBackdrop) {
        wrapper.children[0].onclick = () => {
            onCancel();
            cleanup();
        };
    }

    // Button actions
    const confirmBtn = wrapper.querySelector("#alert-confirm");
    const cancelBtn = wrapper.querySelector("#alert-cancel");

    confirmBtn.onclick = () => {
        onConfirm();
        cleanup();
    };

    if (cancelBtn) {
        cancelBtn.onclick = () => {
            onCancel();
            cleanup();
        };
    }
}
export default CustomAlert;